"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var constants_1 = require("playable/dist/src/constants");
var player_api_decorator_1 = tslib_1.__importDefault(require("playable/dist/src/core/player-api-decorator"));
var config_1 = require("./config");
var load_1 = require("./utils/load");
var ANNOTO_BOOTSTRAP_LINK = 'https://widget.wix.annoto.io/annoto-bootstrap.js';
var ANNOTO_WRAPPER_ID = 'playable-annoto-app-wrapper';
var AnnotoModule = /** @class */ (function () {
    function AnnotoModule(modules) {
        var _this = this;
        this.onFullScreenCallback = lodash_1.noop;
        this.onControlsHideCallback = lodash_1.noop;
        this.onControlsShowCallback = lodash_1.noop;
        this.onTimeUpdateCallback = lodash_1.noop;
        this.onSeekCallback = lodash_1.noop;
        this.onReadyCallback = lodash_1.noop;
        this.onPauseCallback = lodash_1.noop;
        this.onPlayCallback = lodash_1.noop;
        this.onMediaChangeCallback = lodash_1.noop;
        this.handleFullscreenChange = function () {
            _this.onFullScreenCallback();
        };
        this.handleControlsHide = function () {
            _this.onControlsHideCallback();
        };
        this.handleControlsShow = function () {
            _this.onControlsShowCallback();
        };
        this.handleTimeUpdate = function () {
            _this.onTimeUpdateCallback();
        };
        this.handleSeekInProgress = function () {
            _this.onSeekCallback();
        };
        this.handleStateChange = function (_a) {
            var nextState = _a.nextState;
            if (nextState === constants_1.EngineState.METADATA_LOADED) {
                _this.onReadyCallback();
            }
            if (nextState === constants_1.EngineState.PAUSED) {
                _this.onPauseCallback();
            }
            if (nextState === constants_1.EngineState.PLAYING) {
                _this.onPlayCallback();
            }
            if (nextState === constants_1.EngineState.SRC_SET) {
                _this.onMediaChangeCallback();
            }
        };
        var fullScreenManager = modules.fullScreenManager, rootContainer = modules.rootContainer, engine = modules.engine, eventEmitter = modules.eventEmitter, mainUIBlock = modules.mainUIBlock;
        this.fullScreenManager = fullScreenManager;
        this.rootContainer = rootContainer;
        this.engine = engine;
        this.eventEmitter = eventEmitter;
        this.mainUIBlock = mainUIBlock;
        this.annotoWrapper = this.getAnnotoWrapper();
        rootContainer.appendComponentElement(this.annotoWrapper);
        this.annotoAPI = window.Annoto && window.Annoto.api;
        this.handleMetadataChange = lodash_1.noop;
        this.handleUxEvent = lodash_1.noop;
        this.authToken = null;
        this.getMediaId = null;
        this.config = config_1.APPLICATION_CONFIG;
        this.widgetConfig = config_1.WIDGET_CONFIG;
        this.deviceDetector = null;
        this.originProvider = null;
        this.initEventListeners();
    }
    AnnotoModule.prototype.initEventListeners = function () {
        this.eventEmitter.on(constants_1.VIDEO_EVENTS.STATE_CHANGED, this.handleStateChange);
        this.eventEmitter.on(constants_1.VIDEO_EVENTS.SEEK_IN_PROGRESS, this.handleSeekInProgress);
        this.eventEmitter.on(constants_1.VIDEO_EVENTS.CURRENT_TIME_UPDATED, this.handleTimeUpdate);
        this.eventEmitter.on(constants_1.VIDEO_EVENTS.DURATION_UPDATED, this.handleTimeUpdate);
        this.eventEmitter.on(constants_1.UI_EVENTS.MAIN_BLOCK_SHOW, this.handleControlsShow);
        this.eventEmitter.on(constants_1.UI_EVENTS.MAIN_BLOCK_HIDE, this.handleControlsHide);
        this.eventEmitter.on(constants_1.UI_EVENTS.FULL_SCREEN_STATE_CHANGED, this.handleFullscreenChange);
    };
    AnnotoModule.prototype.getAnnotoConfig = function () {
        this.widgetConfig.player = tslib_1.__assign(tslib_1.__assign({}, this.widgetConfig.player), { type: 'custom', element: this.rootContainer.getElement(), api: this.getAnnotoPlayerAdapter() });
        var config = this.config;
        config.widgets = [this.widgetConfig];
        return config;
    };
    AnnotoModule.prototype.getAnnotoWrapper = function () {
        return (document.getElementById(ANNOTO_WRAPPER_ID) || this.createAnnotoWrapper());
    };
    AnnotoModule.prototype.createAnnotoWrapper = function () {
        var annotoApp = document.createElement('div');
        annotoApp.setAttribute('id', 'annoto-app');
        var annotoWrapper = document.createElement('div');
        annotoWrapper.setAttribute('id', ANNOTO_WRAPPER_ID);
        annotoWrapper.setAttribute('style', 'position: relative; z-index: 90');
        annotoWrapper.addEventListener('keydown', function (e) { return e.stopPropagation(); });
        annotoWrapper.appendChild(annotoApp);
        return annotoWrapper;
    };
    AnnotoModule.prototype.updateAnnotoAuth = function () {
        if (!this.annotoAPI) {
            return;
        }
        if (this.authToken) {
            this.annotoAPI.auth(this.authToken);
        }
    };
    AnnotoModule.prototype.initAdditionalComponents = function () {
        if (this.deviceDetector) {
            this.annotoAPI.registerDeviceDetector(this.deviceDetector);
        }
        if (this.originProvider) {
            this.annotoAPI.registerOriginProvider(this.originProvider);
        }
    };
    AnnotoModule.prototype.configureAnnoto = function (params) {
        var clientId = params.clientId, locale = params.locale, ssoAuthRequestHandle = params.ssoAuthRequestHandle, mediaDetailsHandle = params.mediaDetailsHandle, metadataChangeCallback = params.metadataChangeCallback, uxEventCallback = params.uxEventCallback, mediaIdGetter = params.mediaIdGetter, deviceDetector = params.deviceDetector, originProvider = params.originProvider, rtl = params.rtl;
        this.config = tslib_1.__assign(tslib_1.__assign({}, this.config), { clientId: clientId, locale: locale, rtl: rtl, ux: tslib_1.__assign(tslib_1.__assign({}, this.config.ux), { ssoAuthRequestHandle: ssoAuthRequestHandle }) });
        this.deviceDetector = deviceDetector;
        this.originProvider = originProvider;
        this.handleMetadataChange = metadataChangeCallback;
        this.handleUxEvent = uxEventCallback;
        this.getMediaId = mediaIdGetter;
        this.widgetConfig.player = tslib_1.__assign(tslib_1.__assign({}, this.widgetConfig.player), { mediaDetails: mediaDetailsHandle });
    };
    AnnotoModule.prototype.showAnnoto = function () {
        if (this.annotoAPI) {
            this.annotoAPI.show();
        }
    };
    AnnotoModule.prototype.hideAnnoto = function () {
        if (this.annotoAPI) {
            this.annotoAPI.hide();
        }
    };
    AnnotoModule.prototype.disableAnnoto = function () {
        if (this.annotoAPI) {
            this.annotoAPI.close();
        }
    };
    AnnotoModule.prototype.getAnnoto = function () {
        return window.Annoto || this.Annoto;
    };
    AnnotoModule.prototype.enableAnnoto = function () {
        var annoto = this.getAnnoto();
        if (!annoto) {
            this.initAnnoto();
        }
        if (this.annotoAPI) {
            return this.annotoAPI.load(this.getAnnotoConfig());
        }
    };
    AnnotoModule.prototype.setAnnotoAuthToken = function (token) {
        this.authToken = token;
        this.updateAnnotoAuth();
    };
    AnnotoModule.prototype.initAnnoto = function (_Annoto) {
        var _this = this;
        this.Annoto = _Annoto;
        var annoto = this.getAnnoto();
        if (!annoto) {
            this.addScripts();
            return;
        }
        annoto.on('ready', function (api) {
            window.Annoto.api = api;
            _this.annotoAPI = api;
            _this.initAdditionalComponents();
            _this.updateAnnotoAuth();
        });
        annoto.on('metadata', function (metadata) {
            _this.handleMetadataChange(metadata);
        });
        annoto.on('ux', function (uxEvent) {
            _this.handleUxEvent(uxEvent);
        });
        annoto.boot(this.getAnnotoConfig());
    };
    AnnotoModule.prototype.addScripts = function () {
        (0, load_1.addScript)(ANNOTO_BOOTSTRAP_LINK, this.initAnnoto.bind(this));
        // Dark theme
        (0, load_1.addStyle)('https://widget.wix.annoto.io/themes/wix/dist/annoto-theme.css?asvc');
        this.addScripts = lodash_1.noop;
    };
    AnnotoModule.prototype.getMediaSrc = function () {
        if (this.getMediaId) {
            return this.getMediaId();
        }
        return this.engine.attachedAdapter.currentUrl;
    };
    AnnotoModule.prototype.getAnnotoPlayerAdapter = function () {
        var _this = this;
        var _a = this, fullScreenManager = _a.fullScreenManager, engine = _a.engine, rootContainer = _a.rootContainer, mainUIBlock = _a.mainUIBlock;
        return {
            init: function () { return true; },
            isLive: function () {
                return (engine.attachedAdapter &&
                    engine.attachedAdapter.isDynamicContent &&
                    !engine.attachedAdapter.isDynamicContentEnded);
            },
            // Controls
            play: function () { return engine.play(); },
            pause: function () { return engine.pause(); },
            setCurrentTime: function (time) { return engine.setCurrentTime(time); },
            fullScreen: function () { return fullScreenManager.isInFullScreen; },
            embeddableElement: function () { return rootContainer.getElement(); },
            controlsHidden: function () { return !mainUIBlock._isContentShown; },
            currentTime: function () { return engine.getCurrentTime(); },
            duration: function () {
                if (engine.attachedAdapter) {
                    if (engine.attachedAdapter.isSeekAvailable) {
                        return engine.getDuration();
                    }
                    return 0;
                }
                return engine.getDuration();
            },
            paused: function () { return engine.isPaused; },
            mediaSrc: function () { return _this.getMediaSrc(); },
            autoplay: function () { return engine.getAutoplay(); },
            controlsDescriptor: function () { return config_1.CONTROL_DESCRIPTOR; },
            fixFullScreen: function () { return false; },
            // Events
            onReady: function (cb) {
                if (engine.isMetadataLoaded) {
                    cb();
                }
                _this.onReadyCallback = cb;
            },
            onPlay: function (cb) {
                _this.onPlayCallback = cb;
            },
            onPause: function (cb) {
                _this.onPauseCallback = cb;
            },
            onSeek: function (cb) {
                _this.onSeekCallback = cb;
            },
            onTimeUpdate: function (cb) {
                _this.onTimeUpdateCallback = cb;
            },
            onMediaChange: function (cb) {
                _this.onMediaChangeCallback = cb;
            },
            onControlsShow: function (cb) {
                _this.onControlsShowCallback = cb;
            },
            onControlsHide: function (cb) {
                _this.onControlsHideCallback = cb;
            },
            onFullScreen: function (cb) {
                _this.onFullScreenCallback = cb;
            },
            remove: function () {
                _this.onFullScreenCallback = lodash_1.noop;
                _this.onControlsHideCallback = lodash_1.noop;
                _this.onControlsShowCallback = lodash_1.noop;
                _this.onTimeUpdateCallback = lodash_1.noop;
                _this.onSeekCallback = lodash_1.noop;
                _this.onReadyCallback = lodash_1.noop;
                _this.onPauseCallback = lodash_1.noop;
                _this.onPlayCallback = lodash_1.noop;
                _this.onMediaChangeCallback = lodash_1.noop;
            },
        };
    };
    AnnotoModule.prototype.destroy = function () {
        if (this.annotoAPI) {
            this.annotoAPI.close();
        }
        document.body.appendChild(this.annotoWrapper);
        this.eventEmitter.off(constants_1.VIDEO_EVENTS.STATE_CHANGED, this.handleStateChange, this);
        this.eventEmitter.off(constants_1.VIDEO_EVENTS.SEEK_IN_PROGRESS, this.handleSeekInProgress, this);
        this.eventEmitter.off(constants_1.VIDEO_EVENTS.CURRENT_TIME_UPDATED, this.handleTimeUpdate, this);
        this.eventEmitter.off(constants_1.VIDEO_EVENTS.DURATION_UPDATED, this.handleTimeUpdate, this);
        this.eventEmitter.off(constants_1.UI_EVENTS.MAIN_BLOCK_SHOW, this.handleControlsShow, this);
        this.eventEmitter.off(constants_1.UI_EVENTS.MAIN_BLOCK_HIDE, this.handleControlsHide, this);
        this.eventEmitter.off(constants_1.UI_EVENTS.FULL_SCREEN_STATE_CHANGED, this.handleFullscreenChange, this);
        this.annotoWrapper = null;
        this.annotoAPI = null;
        this.engine = null;
    };
    AnnotoModule.moduleName = 'annoto';
    AnnotoModule.dependencies = [
        'eventEmitter',
        'engine',
        'rootContainer',
        'fullScreenManager',
        'mainUIBlock',
    ];
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "configureAnnoto", null);
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "showAnnoto", null);
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "hideAnnoto", null);
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "disableAnnoto", null);
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "enableAnnoto", null);
    tslib_1.__decorate([
        (0, player_api_decorator_1.default)()
    ], AnnotoModule.prototype, "setAnnotoAuthToken", null);
    return AnnotoModule;
}());
exports.default = AnnotoModule;
//# sourceMappingURL=module.js.map